import React from "react";
import "./useful-links.css";
import { Link } from "react-router-dom";
import ScrollToTop from "../../components/ScrollToTop";
import { useUsefulLinks } from "../../hooks/usefulLinksHooks.js";

const UsefulLinks = () => {
  const { title, description, links, note, loading, error } = useUsefulLinks();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <section className="usefulLinks">
        <div className="container">
          <div className="txtContent">
            <div className="header">
              <h3>{title}</h3>
              <p>{description}</p>
            </div>

            <div className="content">
              <ul>
                {links.map((link, index) => (
                  <li key={index} className="linkItem">
                    <div className="title">
                      {index + 1}. {link.title}
                    </div>
                    <article>
                      <strong>Link: </strong>
                      <Link target="_blank" to={link.url}>
                        {link.url}
                      </Link>
                      <br />
                      <strong>Description: </strong>
                      {link.description}
                    </article>
                  </li>
                ))}
              </ul>

              <p>{note}</p>
            </div>
          </div>
        </div>
      </section>
      <ScrollToTop />
    </>
  );
};

export default UsefulLinks;
